<div class="tooltip-container">
    <mat-card class="mat-elevation-z5">
        <mat-card-content class="data-container">
            <p>{{data.name}}
                <span *ngIf="data.status">
                    {{'(' + data.status + ')'}}
                </span>
            </p>
            <span *ngIf="data.description" class="divider-vertical"></span>
            <p *ngIf="data.description">{{data.description}}</p>
        </mat-card-content>
    </mat-card>
</div>
